import { Fragment } from 'react';
import Image from 'next/image';
import CustomLink from '@common/CustomLink';
import { TitleWrapper } from '@views/Home/components';
import { useHomeContext } from '@views/Home/HomeProvider/HomeContext';
import { env } from 'env.mjs';

import { ImageOrSvg } from '@/components/common/ImgOrSvg';
import { PageTaxesBlock } from '@/components/common/Providers/GraphqlProvider/generated';
import SvgBgPrimary from '@/components/common/SvgBgPrimary/SvgBgPrimary';

import styles from './styles.module.css';

const Taxes = ({ currentPageTaxesBlock }: { currentPageTaxesBlock?: PageTaxesBlock }) => {
  const {
    home: { taxesBlock: taxesBlockContext },
  } = useHomeContext();

  const taxesBlock = currentPageTaxesBlock || taxesBlockContext;

  if (taxesBlock?.isDisabled) return null;

  return (
    <section className={'inner-extend mt-10'}>
      <TitleWrapper
        title1={taxesBlock?.showTitle ? taxesBlock?.blockTitle?.split(' ')[0] : ''}
        title2={taxesBlock?.showTitle ? taxesBlock?.blockTitle?.split(' ').slice(1).join(' ') : ''}
        description={taxesBlock?.showDescription ? taxesBlock.publicDescription : ''}
        action={{
          text: 'Ver más',
          onClick: () => window.open(`${process.env.NEXT_PUBLIC_PORTAL_TRIBUTARIO}/`),
        }}
      />

      <div className={styles.taxes}>
        {[...(taxesBlock?.items ?? [])]
          ?.sort((a: any, b: any) => a.orderIndex - b.orderIndex)
          .map((tax, key) => (
            <Fragment key={key}>
              <CustomLink pageLink={tax.linkItem} className={styles.tax} key={key}>
                {tax.image && (
                  <div className={styles.iconWrapper}>
                    {/* <ImageOrSvg height={25} width={30} url={`${tax.image?.downloadUrl}`} /> */}
                    <ImageOrSvg
                      classNameSvg="[&>svg]:!size-[25px] text-primary flex items-center justify-center size-[25px]"
                      height={25}
                      width={30}
                      url={
                        env.NEXT_PUBLIC_BASE_URL + '/attachment/files/download/' + tax?.image?.id
                      }
                    />
                  </div>
                )}
                <div
                  className={
                    'headline-h6 overflow-hidden text-ellipsis whitespace-nowrap text-white'
                  }
                  title={tax.taxTitle}
                >
                  {tax.taxTitle}
                </div>
              </CustomLink>
            </Fragment>
          ))}
      </div>
    </section>
  );
};

export default Taxes;

export function TaxesSkeleton() {
  return (
    <section className="inner-extend mt-10">
      <div className="animate-pulse">
        <div className="mb-2 h-4 w-48 rounded bg-gray-200" />
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
          <div className="h-28 w-full rounded bg-gray-200" />
          <div className="h-28 w-full rounded bg-gray-200" />
          <div className="h-28 w-full rounded bg-gray-200" />
          <div className="h-28 w-full rounded bg-gray-200" />
        </div>
      </div>
    </section>
  );
}
